import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "main-content",
  class: "text-muted flex-grow px-4 py-2 md:px-12 md:py-4 w-full max-w-[37.50rem]"
}
const _hoisted_2 = {
  key: 0,
  class: "leading-none mt-[5vw] mb-[1vw]"
}
const _hoisted_3 = { class: "text-2xl" }
const _hoisted_4 = {
  key: 0,
  class: "block md:flex flex-row flex-wrap mt-1 leading-normal uppercase text-xs"
}
const _hoisted_5 = { class: "mr-4" }
const _hoisted_6 = { class: "mr-4" }
const _hoisted_7 = ["textContent"]

import { defineLink } from '@unhead/vue'

import { needsRuntimeDiscovery, newestPostPath } from '#build/bsky-runtime-discovery.mjs'


export default /*@__PURE__*/_defineComponent({
  __name: '[article]',
  async setup(__props) {

let __temp: any, __restore: any

const standardSiteDid = useRuntimeConfig().public.atproto?.did || null

const route = useRoute('blog-article')
const slug = route.params.article
if (!slug) navigateTo('/blog')

const path = computed(() =>
  route.path.replace(/(index)?\.json$/, '').replace(/\/$/, ''),
)

const { data: page } = (
  ([__temp,__restore] = _withAsyncContext(async () => useAsyncData(
  path.value,
  async () => {
    if (!import.meta.server && !import.meta.dev) return null
    const { blogEntries } = await import('#build/markdown/blog-entries.mjs')
    const slug = path.value.replace(/^\/blog\//, '').replace(/\/$/, '')
    const entry = blogEntries.find(e => e.path === `/blog/${slug}`)
    if (!entry) {
      return null
    }
    return {
      title: entry.title,
      date: entry.date,
      tid: entry.tid,
      description: entry.description,
      tags: entry.tags,
      bluesky: entry.bluesky,
    }
  },
))),
  __temp = await __temp,
  __restore(),
  __temp
)

if (!page.value) {
  throw createError({
    status: 404,
    fatal: true,
  })
}

route.meta.title = page.value.title

const formatter = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric',
})

defineOgImage('DefaultImage', {
  date: formatter.format(new Date(page.value.date)),
  title: page.value.title,
  tags: page.value.tags,
})

if (import.meta.server) {
  useRoute().meta.description = page.value.description

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    'headline': page.value.title,
    'description': page.value.description,
    'datePublished': page.value.date,
    'author': {
      '@type': 'Person',
      'name': 'Daniel Roe',
      'url': 'https://roe.dev',
    },
    'publisher': {
      '@type': 'Person',
      'name': 'Daniel Roe',
      'url': 'https://roe.dev',
    },
    'mainEntityOfPage': {
      '@type': 'WebPage',
      '@id': `https://roe.dev${path.value}`,
    },
    'keywords': page.value.tags?.join(', '),
  }

  useHead({
    script: [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(articleSchema),
      },
    ],
    link: [
      ...(standardSiteDid && page.value.tid)
        ? [defineLink({ rel: 'site.standard.document', href: `at://${standardSiteDid}/site.standard.document/${page.value.tid}` })]
        : [],
    ],
  })
}

const blueskyUri = shallowRef(page.value.bluesky)

if (import.meta.client && needsRuntimeDiscovery && !blueskyUri.value && newestPostPath === path.value) {
  onMounted(async () => {
    const { uri } = await $fetch<{ uri: string | null }>('/api/discover-bluesky-post').catch(() => ({ uri: null }))
    if (uri) {
      blueskyUri.value = uri
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_NuxtTime = _resolveComponent("NuxtTime")!
  const _component_StaticMarkdownRender = _resolveComponent("StaticMarkdownRender")!
  const _component_LazyBlueskyComments = _resolveComponent("LazyBlueskyComments")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_unref(page))
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(page).title), 1),
          (_unref(page).date)
            ? (_openBlock(), _createElementBlock("dl", _hoisted_4, [
                _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "float-left md:float-none mr-2" }, " Published ", -1)),
                _createElementVNode("dd", _hoisted_5, [
                  _createVNode(_component_NuxtTime, {
                    datetime: _unref(page).date,
                    day: "numeric",
                    month: "long",
                    year: "numeric"
                  }, null, 8, ["datetime"])
                ]),
                (_unref(page).tags && _unref(page).tags.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "float-left md:float-none mr-2" }, " Tags ", -1)),
                      _createElementVNode("dd", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(page).tags, (tag, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: tag,
                            class: _normalizeClass({
                'before:content-empty before:mx-1 before:inline-block': index,
              }),
                            textContent: _toDisplayString(tag)
                          }, null, 10, _hoisted_7))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(page))
      ? (_openBlock(), _createElementBlock("section", {
          key: 1,
          class: _normalizeClass(_ctx.$style.blog)
        }, [
          _createVNode(_component_StaticMarkdownRender, {
            collection: "blog",
            path: _unref(path)
          }, null, 8, ["path"])
        ], 2))
      : _createCommentVNode("", true),
    (_unref(blueskyUri))
      ? (_openBlock(), _createBlock(_component_LazyBlueskyComments, {
          key: 2,
          uri: _unref(blueskyUri)
        }, null, 8, ["uri"]))
      : _createCommentVNode("", true)
  ]))
}
}

})